export const PageContainer = ({ children }) => (
  <div className="px-4 sm:px-8 xl:px-0 xl:max-w-[1120px] mx-auto my-10">{children}</div>
)
